/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_search_results_for_text20 = /** @type {(inputs: { count: NonNullable<unknown>, search: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("en", i.count, {});
	return `Found ${i.count} result for: ${i.search}`
	if (countPlural == "one") return `Found ${i.count} result for: ${i.search}`;
	if (countPlural == "other") return `Found ${i.count} results for: ${i.search}`;
	
};

const fr_search_results_for_text20 = /** @type {(inputs: { count: NonNullable<unknown>, search: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("fr", i.count, {});
	return `Résultat ${i.count} trouvé pour : ${i.search}`
	if (countPlural == "one") return `Résultat ${i.count} trouvé pour : ${i.search}`;
	if (countPlural == "other") return `Résultats trouvés pour : ${i.count} ${i.search}`;
	
};

const de_search_results_for_text20 = /** @type {(inputs: { count: NonNullable<unknown>, search: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("de", i.count, {});
	return `${i.count} Ergebnis gefunden für: ${i.search}`
	if (countPlural == "one") return `${i.count} Ergebnis gefunden für: ${i.search}`;
	if (countPlural == "other") return `Es wurden ${i.count} Ergebnisse gefunden für: ${i.search}`;
	
};

const es_search_results_for_text20 = /** @type {(inputs: { count: NonNullable<unknown>, search: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("es", i.count, {});
	return `Se encontró el resultado ${i.count} para: ${i.search}`
	if (countPlural == "one") return `Se encontró el resultado ${i.count} para: ${i.search}`;
	if (countPlural == "other") return `Resultados encontrados para: ${i.count} ${i.search}`;
	
};

const it_search_results_for_text20 = /** @type {(inputs: { count: NonNullable<unknown>, search: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("it", i.count, {});
	return `Trovati ${i.count} risultati per: ${i.search}`
	if (countPlural == "one") return `Trovati ${i.count} risultati per: ${i.search}`;
	if (countPlural == "other") return `Trovati ${i.count} risultati per: ${i.search}`;
	
};

const ar_search_results_for_text20 = /** @type {(inputs: { count: NonNullable<unknown>, search: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("ar", i.count, {});
	return `تم العثور على نتيجة ${i.count} لـ: ${i.search}`
	if (countPlural == "one") return `تم العثور على نتيجة ${i.count} لـ: ${i.search}`;
	if (countPlural == "other") return `تم العثور على ${i.count} نتيجة لـ: ${i.search}`;
	
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown>, search: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_results_for_text20 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_results_for_text20(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_results_for_text20", locale)
	if (locale === "en") return en_search_results_for_text20(inputs)
	if (locale === "fr") return fr_search_results_for_text20(inputs)
	if (locale === "de") return de_search_results_for_text20(inputs)
	if (locale === "es") return es_search_results_for_text20(inputs)
	if (locale === "it") return it_search_results_for_text20(inputs)
	return ar_search_results_for_text20(inputs)
};
export { search_results_for_text20 as "SEARCH_RESULTS_FOR_TEXT" }